<template>
  <div class="pa-4">
    <div class="d-flex align-center mb-4">
      <h2 class="text-h5 font-weight-bold">Tichete HR</h2>
      <v-spacer />
      <v-btn color="red-darken-1" prepend-icon="mdi-plus" @click="dialogTicket = true">Tichet nou</v-btn>
    </div>

    <DxDataGrid
      :data-source="dataSource"
      :show-borders="true"
      :row-alternation-enabled="true"
      :remote-operations="true"
    >
      <DxColumn data-field="DataCreare" caption="Data" data-type="datetime" format="dd.MM.yyyy HH:mm" :width="150" />
      <DxColumn data-field="Stare" caption="Stare" :width="140" cell-template="stareCellTemplate" />
      <DxColumn data-field="PriorityID" caption="Prioritate" :width="110" />
      <DxColumn data-field="UserMessage" caption="Mesaj" />
      <DxColumn data-field="HRMessage" caption="Răspuns HR" />
      <DxColumn data-field="DataInchidere" caption="Închis la" data-type="datetime" format="dd.MM.yyyy" :width="120" />

      <template #stareCellTemplate="{ data }">
        <v-chip :color="stareColor(data.data.Stare)" size="small" variant="tonal">{{ data.data.Stare }}</v-chip>
      </template>

      <DxPaging :page-size="15" />
      <DxFilterRow :visible="true" />
    </DxDataGrid>

    <!-- Dialog tichet nou -->
    <v-dialog v-model="dialogTicket" max-width="500" persistent>
      <v-card rounded="xl">
        <v-card-title class="pa-4">
          <v-icon class="mr-2" color="blue-darken-1">mdi-ticket</v-icon>
          Tichet HR nou
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <v-form v-model="ticketValid" ref="ticketForm">
            <v-select
              v-model="ticketForm.DocumentTypeID"
              :items="tipuriDoc"
              item-title="Denumire"
              item-value="ID"
              label="Tip document"
              variant="outlined"
              density="compact"
              class="mb-3"
              :rules="[required]"
              :loading="loadingTipuri"
            />
            <v-select
              v-model="ticketForm.PriorityID"
              :items="['Normal', 'Urgent']"
              label="Prioritate"
              variant="outlined"
              density="compact"
              class="mb-3"
            />
            <v-textarea
              v-model="ticketForm.UserMessage"
              label="Mesaj / Detalii"
              variant="outlined"
              density="compact"
              rows="3"
              :rules="[required]"
            />
          </v-form>
          <v-alert v-if="ticketError" type="error" variant="tonal" class="mt-2">{{ ticketError }}</v-alert>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-btn variant="text" @click="dialogTicket = false">Anulează</v-btn>
          <v-spacer />
          <v-btn color="blue-darken-1" :loading="ticketLoading" :disabled="!ticketValid" @click="submitTicket">
            Trimite
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { DxDataGrid, DxColumn, DxPaging, DxFilterRow } from 'devextreme-vue/data-grid'
import DataSource from 'devextreme/data/data_source'
import PORTAL_Tickets from '@/services/Portal/PORTAL_Tickets'
import http from "@/settings/apiSettings"

export default defineComponent({
  name: 'Tichete',
  components: { DxDataGrid, DxColumn, DxPaging, DxFilterRow },
  data() {
    return {
      dataSource: new DataSource({ store: PORTAL_Tickets.getODataStore() }),
      dialogTicket: false,
      ticketValid: false,
      ticketLoading: false,
      loadingTipuri: false,
      ticketError: '',
      tipuriDoc: [] as any[],
      ticketForm: { DocumentTypeID: '', PriorityID: 'Normal', UserMessage: '' }
    }
  },
  async mounted() {
    this.loadingTipuri = true;
    try {
      const resp = await http.clientPortalHROdata.get('/PORTAL_DocumentTypes?$filter=IsActiv eq true', {
        headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
      });
      this.tipuriDoc = resp.data?.value ?? [];
    } finally {
      this.loadingTipuri = false;
    }
  },
  methods: {
    required(v: any) { return !!v || 'Câmp obligatoriu' },
    stareColor(stare: string) {
      const map: Record<string, string> = { deschis: 'blue', 'in_lucru': 'amber', inchis: 'grey', rezolvat: 'green' };
      return map[stare] ?? 'grey';
    },
    async submitTicket() {
      this.ticketLoading = true; this.ticketError = '';
      try {
        await PORTAL_Tickets.add(this.ticketForm);
        this.dialogTicket = false;
        this.dataSource.reload();
      } catch (e: any) {
        this.ticketError = e?.response?.data?.message ?? 'Eroare la trimitere.';
      } finally {
        this.ticketLoading = false;
      }
    }
  }
})
</script>
